<template>
<div v-if="open" class="cd-dock" :class="{ minimized: minimized }">
  <!-- header -->
  <div class="cd-head" @click="minimized ? restore() : null">
    <div class="cd-head-id" @click.stop="goProfile">
      <div class="cd-av-wrap" :class="{online:false}"><user-avatar :src="otherAvatar" :name="otherName" size="sm" /></div>
      <div class="cd-head-name">{{ otherName || 'Chat' }}</div>
    </div>
    <div class="cd-head-actions">
      <button class="cd-hbtn" title="Open full chat" @click.stop="openFull"><i class="mdi mdi-arrow-expand"></i></button>
      <button class="cd-hbtn" :title="minimized ? 'Expand' : 'Minimize'" @click.stop="minimized ? restore() : minimize()"><i class="mdi" :class="minimized ? 'mdi-chevron-up' : 'mdi-minus'"></i></button>
      <button class="cd-hbtn" title="Close" @click.stop="close"><i class="mdi mdi-close"></i></button>
    </div>
  </div>

  <template v-if="!minimized">
    <!-- messages -->
    <div class="cd-body" ref="body">
      <div v-if="loading" class="cd-loading"><span class="spinner-border spinner-border-sm text-warning"></span></div>
      <div v-else-if="!messages.length" class="cd-empty">
        <user-avatar :src="otherAvatar" :name="otherName" size="lg" />
        <div class="cd-empty-name">{{ otherName }}</div>
        <div class="cd-empty-sub">Say hello 👋</div>
      </div>
      <template v-else>
        <div v-for="m in messages" :key="m.id" class="cd-msg" :class="{ mine: isMine(m) }">
          <div class="cd-bubble" :class="{'cd-bubble-media': isMediaMsg(m)}">
            <!-- IMAGE -->
            <img v-if="(m.message_type==='image'||m.message_type==='photo') && m.file_url" :src="pu(m.file_url)" class="cd-img" @click="openImg(m.file_url)" />
            <!-- VIDEO -->
            <video v-else-if="m.message_type==='video' && m.file_url" :src="pu(m.file_url)" controls preload="metadata" playsinline class="cd-video"></video>
            <!-- DOCUMENT -->
            <div v-else-if="(m.message_type==='document'||m.message_type==='file') && m.file_url" class="cd-doc" @click="openImg(m.file_url)">
              <i class="mdi mdi-file-document-outline cd-doc-icon"></i>
              <div class="cd-doc-info">
                <div class="cd-doc-name">{{ docName(m) }}</div>
                <div class="cd-doc-sub">Tap to open</div>
              </div>
            </div>
            <!-- LISTING CARD -->
            <div v-if="msgCard(m)" class="cd-listing" @click="openListing(msgCard(m))">
              <img v-if="msgCard(m).photo" :src="pu(msgCard(m).photo)" class="cd-listing-img" />
              <div class="cd-listing-info">
                <div class="cd-listing-title">{{ msgCard(m).title || 'Listing' }}</div>
                <div v-if="msgCard(m).price" class="cd-listing-price">KES {{ msgCard(m).price }}</div>
              </div>
            </div>
            <span v-if="msgText(m)" class="cd-text">{{ msgText(m) }}</span>
          </div>
        </div>
      </template>
    </div>

    <!-- Attachment preview row (visible only when a file is queued) -->
    <div v-if="pendingFile" class="cd-preview">
      <div class="cd-preview-thumb">
        <img v-if="pendingType==='photo' && pendingPreview" :src="pendingPreview" />
        <video v-else-if="pendingType==='video' && pendingPreview" :src="pendingPreview" muted></video>
        <i v-else class="mdi mdi-file-document-outline"></i>
      </div>
      <div class="cd-preview-name">{{ pendingFile.name }}</div>
      <button class="cd-preview-x" @click="clearPending" title="Remove"><i class="mdi mdi-close"></i></button>
    </div>

    <!-- composer -->
    <div class="cd-composer">
      <div class="cd-attach-wrap">
        <button class="cd-attach" @click="attachMenu=!attachMenu" :disabled="sending" title="Attach"><i class="mdi mdi-paperclip"></i></button>
        <div v-if="attachMenu" class="cd-attach-menu" @click.self="attachMenu=false">
          <button @click="pickImage"><i class="mdi mdi-image-outline"></i>Photo</button>
          <button @click="pickVideo"><i class="mdi mdi-video-outline"></i>Video</button>
          <button @click="pickDoc"><i class="mdi mdi-file-document-outline"></i>Document</button>
        </div>
      </div>
      <input v-model="input" class="cd-input" :placeholder="pendingFile ? 'Add a caption (optional)' : 'Aa'" @keyup.enter="send" :disabled="sending" />
      <button class="cd-send" @click="send" :disabled="sending || (!input.trim() && !pendingFile)"><i class="mdi" :class="sending ? 'mdi-loading mdi-spin' : 'mdi-send'"></i></button>
    </div>

    <!-- Hidden file inputs -->
    <input type="file" ref="imageInput" accept="image/*" @change="onImageSelected" hidden />
    <input type="file" ref="videoInput" accept="video/*" @change="onVideoSelected" hidden />
    <input type="file" ref="docInput" accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.zip" @change="onDocSelected" hidden />
  </template>
</div>
</template>

<script>
/* eslint-disable */
import { execute, executeJson, flocker, uploads } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";

export default {
  name: "ChatDock",
  components: { UserAvatar },
  data(){return{
    open:false, minimized:false, loading:false, sending:false,
    conversationId:'', otherId:'', otherName:'', otherAvatar:'',
    contextType:'general', contextId:'', listingId:'',
    messages:[], input:'', pollTimer:null,
    attachMenu:false,
    pendingFile:null, pendingType:'', pendingPreview:''
  }},
  computed:{
    myUserId(){ return sessionStorage.getItem('userId') || ''; }
  },
  mounted(){
    var self=this;
    this._onOpen = function(e){ self.openChat(e.detail || {}); };
    window.addEventListener('flockr-open-chat', this._onOpen);
  },
  beforeUnmount(){
    if(this._onOpen) window.removeEventListener('flockr-open-chat', this._onOpen);
    if(this.pollTimer) clearInterval(this.pollTimer);
  },
  methods:{
    pu(p){ if(!p) return ''; if(String(p).indexOf('http')===0) return p; return uploads + String(p).replace(/^uploads\//,''); },
    isMine(m){ return m.sender_id === this.myUserId; },
    isMediaMsg(m){
      var t = m.message_type;
      return (t==='image'||t==='photo'||t==='video'||t==='document'||t==='file');
    },
    parseJson(c){ if(!c) return null; var s=String(c).trim(); if(s.charAt(0)!=='{') return null; try{ return JSON.parse(s); }catch(e){ return null; } },
    msgCard(m){ var o=this.parseJson(m.content); return (o && o._type==='listing_card') ? o : null; },
    msgText(m){
      var o=this.parseJson(m.content);
      if(!o) return m.content;
      if(o._type==='listing_card') return o.text || '';
      if(o._type==='location') return '📍 ' + (o.label || 'Shared location');
      if(o._type) return o.text || ('Sent a ' + String(o._type).replace(/_/g,' '));
      return o.text || '';
    },
    docName(m){
      if(m.file_name) return m.file_name;
      if(!m.file_url) return 'Document';
      var parts = String(m.file_url).split('/');
      return parts[parts.length-1] || 'Document';
    },
    openListing(card){ if(card && card.listing_id){ this.$router.push('/marketplace/listing/'+card.listing_id); } },
    async openChat(opts){
      if(!this.myUserId){ this.$router.push('/login'); return; }
      if(!opts.userId && !opts.conversationId) return;
      this.open=true; this.minimized=false;
      this.otherId = opts.userId || this.otherId;
      this.otherName = opts.name || this.otherName || 'Chat';
      this.otherAvatar = opts.avatar || '';
      this.contextType = opts.contextType || 'general';
      this.contextId = opts.contextId || '';
      this.listingId = opts.listingId || '';
      this.messages=[]; this.clearPending();
      this.conversationId = opts.conversationId || '';
      this.loading=true;
      if(!this.conversationId && this.otherId){
        try{ var r=await executeJson({
            function:'getOrCreateConversation', userA:this.myUserId, userB:this.otherId,
            contextType:this.contextType, contextId:this.contextId
          },flocker);
          if(r.data&&r.data.success) this.conversationId=r.data.data.conversationId; }catch(e){}
      }
      await this.loadMessages();
      this.loading=false;
      this._startPoll();
    },
    async loadMessages(){
      if(!this.conversationId) return;
      try{
        var r=await executeJson({function:'getMessages',conversationId:this.conversationId,userId:this.myUserId,limit:40},flocker);
        if(r.data&&r.data.success){
          var msgs=(r.data.data&&r.data.data.messages)||[];
          this.messages=msgs.slice().reverse();
          this.$nextTick(this.scrollBottom);
        }
      }catch(e){}
    },

    // === Attachments ===
    pickImage(){this.attachMenu=false; this.$refs.imageInput && this.$refs.imageInput.click();},
    pickVideo(){this.attachMenu=false; this.$refs.videoInput && this.$refs.videoInput.click();},
    pickDoc(){this.attachMenu=false; this.$refs.docInput && this.$refs.docInput.click();},
    onImageSelected(e){
      var file = e.target.files && e.target.files[0]; if(!file) return; e.target.value='';
      var self=this;
      this.compressImage(file, 1280, 0.78).then(function(result){
        self.pendingFile = result.file;
        self.pendingType = 'photo';
        self.pendingPreview = result.dataUrl;
      });
    },
    onVideoSelected(e){
      var file = e.target.files && e.target.files[0]; if(!file) return; e.target.value='';
      // Soft cap: 30MB. Anything bigger should go through full chat page.
      if(file.size > 30 * 1024 * 1024){
        alert('Video is too large for quick chat (max 30MB). Open full chat to send larger files.');
        return;
      }
      this.pendingFile = file;
      this.pendingType = 'video';
      // Simple preview using object URL
      try{ this.pendingPreview = URL.createObjectURL(file); }catch(e){ this.pendingPreview = ''; }
    },
    onDocSelected(e){
      var file = e.target.files && e.target.files[0]; if(!file) return; e.target.value='';
      if(file.size > 15 * 1024 * 1024){
        alert('Document is too large (max 15MB). Open full chat to send larger files.');
        return;
      }
      this.pendingFile = file;
      this.pendingType = 'file';
      this.pendingPreview = '';
    },
    clearPending(){
      if(this.pendingPreview && this.pendingType==='video' && this.pendingPreview.indexOf('blob:')===0){
        try{ URL.revokeObjectURL(this.pendingPreview); }catch(e){}
      }
      this.pendingFile = null; this.pendingType = ''; this.pendingPreview = '';
    },
    compressImage(file, maxDim, quality){
      return new Promise(function(resolve){
        if(!file.type.startsWith('image/') || file.size < 100000){
          var r = new FileReader();
          r.onload = function(ev){ resolve({file:file, dataUrl:ev.target.result}); };
          r.readAsDataURL(file); return;
        }
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function(){
          URL.revokeObjectURL(url);
          var w = img.width, h = img.height;
          if(w > maxDim || h > maxDim){
            if(w > h){ h = Math.round(h * maxDim / w); w = maxDim; }
            else { w = Math.round(w * maxDim / h); h = maxDim; }
          }
          var canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          canvas.toBlob(function(blob){
            var compressed = new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), {type:'image/jpeg'});
            resolve({file:compressed, dataUrl:canvas.toDataURL('image/jpeg', quality)});
          }, 'image/jpeg', quality);
        };
        img.onerror = function(){
          URL.revokeObjectURL(url);
          var r = new FileReader();
          r.onload = function(ev){ resolve({file:file, dataUrl:ev.target.result}); };
          r.readAsDataURL(file);
        };
        img.src = url;
      });
    },

    async send(){
      var txt=(this.input||'').trim();
      var hasFile = !!this.pendingFile;
      if(!txt && !hasFile) return;
      if(this.sending) return;
      if(!this.otherId){ return; }
      this.sending=true;

      // Optimistic bubble
      var msgType = hasFile ? (this.pendingType==='photo' ? 'photo' : this.pendingType) : 'text';
      var tmp = {
        id:'tmp-'+Date.now(),
        sender_id:this.myUserId,
        content: txt,
        message_type: msgType,
        file_url: hasFile ? this.pendingPreview : null,
        file_name: hasFile && this.pendingFile ? this.pendingFile.name : null
      };
      this.messages.push(tmp);
      var fileToSend = this.pendingFile;
      var typeToSend = this.pendingType;
      this.input=''; this.clearPending();
      this.$nextTick(this.scrollBottom);

      try{
        var fd=new FormData();
        fd.append('function','sendMessage');
        fd.append('senderId',this.myUserId);
        fd.append('receiverId',this.otherId);
        fd.append('content', txt);
        fd.append('messageType', msgType);
        fd.append('contextType', this.contextType || 'general');
        if(this.contextId) fd.append('contextId', this.contextId);
        if(this.listingId) fd.append('listingId', this.listingId);
        if(this.conversationId) fd.append('conversationId', this.conversationId);
        if(fileToSend) fd.append('file', fileToSend);
        var r=await execute(fd,flocker);
        if(r.data&&r.data.success&&r.data.data&&r.data.data.conversationId){ this.conversationId=r.data.data.conversationId; }
        await this.loadMessages();
      }catch(e){
        // Roll the optimistic message back & restore the queued file so user can retry
        this.messages = this.messages.filter(function(m){return m.id !== tmp.id;});
        this.pendingFile = fileToSend; this.pendingType = typeToSend;
        this.input = txt;
        alert('Could not send. Check your connection and try again.');
      }
      this.sending=false;
    },
    _startPoll(){
      var self=this;
      if(this.pollTimer) clearInterval(this.pollTimer);
      this.pollTimer=setInterval(function(){ if(self.open && !self.minimized) self.loadMessages(); }, 7000);
    },
    scrollBottom(){ var el=this.$refs.body; if(el) el.scrollTop=el.scrollHeight; },
    minimize(){ this.minimized=true; },
    restore(){ this.minimized=false; this.$nextTick(this.scrollBottom); this.loadMessages(); },
    close(){ this.open=false; this.clearPending(); if(this.pollTimer){ clearInterval(this.pollTimer); this.pollTimer=null; } },
    openFull(){ if(this.conversationId){ this.close(); this.$router.push('/messages/'+this.conversationId); } },
    goProfile(){ if(this.otherId) this.$router.push('/u/'+this.otherId); },
    openImg(u){ window.open(this.pu(u),'_blank'); }
  }
};
</script>

<style>
html[data-theme="light"] .cd-dock{background:#FFFFFF!important;border-color:#E2DCD3!important}
html[data-theme="light"] .cd-head{background:#FFFFFF!important;border-bottom-color:#E2DCD3!important}
html[data-theme="light"] .cd-head-name,
html[data-theme="light"] .cd-empty-name{color:#1A1A1A!important}
html[data-theme="light"] .cd-empty-sub{color:#777!important}
html[data-theme="light"] .cd-hbtn{color:#777!important}
html[data-theme="light"] .cd-body{background:#FFFFFF!important}
html[data-theme="light"] .cd-bubble{background:#EBE7E1!important;color:#1A1A1A!important}
html[data-theme="light"] .cd-input::placeholder{color:#999!important}
html[data-theme="light"] .cd-msg.mine .cd-bubble{background:linear-gradient(135deg,#D4B679,#BFA164)!important;color:#231807!important}
html[data-theme="light"] .cd-input{background:#EBE7E1!important;color:#1A1A1A!important}
html[data-theme="light"] .cd-composer{background:#FFFFFF!important;border-top-color:#E2DCD3!important}
html[data-theme="light"] .cd-preview{background:#F7F5F2!important;border-top-color:#E2DCD3!important;color:#1A1A1A!important}
html[data-theme="light"] .cd-attach-menu{background:#FFFFFF!important;border-color:#E2DCD3!important;color:#1A1A1A!important}
html[data-theme="light"] .cd-attach-menu button{color:#1A1A1A!important}
html[data-theme="light"] .cd-attach-menu button:hover{background:#F0EBE4!important}
</style>

<style scoped>
.cd-dock{position:fixed;right:22px;bottom:0;width:330px;max-width:calc(100vw - 24px);height:444px;max-height:78vh;background:#141414;border:1px solid #2A2520;border-bottom:none;border-radius:12px 12px 0 0;box-shadow:0 8px 40px rgba(0,0,0,.5);z-index:3000;display:flex;flex-direction:column;overflow:hidden}
.cd-dock.minimized{height:auto;width:300px}
.cd-head{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 10px;background:#141414;border-bottom:1px solid #2A2520;cursor:pointer}
.cd-head-id{display:flex;align-items:center;gap:8px;min-width:0;cursor:pointer}
.cd-head-name{color:#F5F0E8;font-weight:700;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.cd-head-actions{display:flex;align-items:center;gap:2px;flex-shrink:0}
.cd-hbtn{width:30px;height:30px;border:none;background:none;color:#A09888;font-size:18px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center}
.cd-hbtn:hover{background:rgba(255,255,255,.08);color:#BFA164}
.cd-body{flex:1;overflow-y:auto;padding:12px;display:flex;flex-direction:column;gap:4px;background:#0F0F0F}
.cd-loading{flex:1;display:flex;align-items:center;justify-content:center}
.cd-empty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;text-align:center}
.cd-empty-name{color:#F5F0E8;font-weight:700;font-size:14px;margin-top:8px}
.cd-empty-sub{color:#6B6356;font-size:13px}
.cd-msg{display:flex;max-width:100%}
.cd-msg.mine{justify-content:flex-end}
.cd-bubble{max-width:80%;padding:7px 11px;border-radius:16px;background:#262626;color:#F5F0E8;font-size:14px;line-height:1.4;word-wrap:break-word;display:flex;flex-direction:column;gap:4px}
.cd-bubble-media{padding:4px 6px 7px}
.cd-msg.mine .cd-bubble{background:linear-gradient(135deg,#CDAC6B,#BFA164);color:#231807;border-bottom-right-radius:4px}
.cd-msg:not(.mine) .cd-bubble{border-bottom-left-radius:4px}
.cd-text{display:inline-block}
.cd-img{max-width:200px;max-height:220px;border-radius:10px;display:block;cursor:pointer}
.cd-video{max-width:220px;max-height:220px;border-radius:10px;display:block;background:#000}
.cd-doc{display:flex;align-items:center;gap:8px;background:rgba(0,0,0,.18);border-radius:10px;padding:7px 10px;cursor:pointer;max-width:240px}
.cd-doc-icon{font-size:24px;color:#BFA164;flex-shrink:0}
.cd-doc-info{min-width:0}
.cd-doc-name{font-size:13px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.2}
.cd-doc-sub{font-size:11px;opacity:.7;margin-top:1px}

.cd-listing{display:flex;align-items:center;gap:8px;background:rgba(0,0,0,.14);border-radius:10px;padding:6px;cursor:pointer;max-width:240px}
.cd-listing-img{width:44px;height:44px;border-radius:8px;object-fit:cover;flex-shrink:0;background:rgba(0,0,0,.1)}
.cd-listing-info{min-width:0}
.cd-listing-title{font-size:13px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.2}
.cd-listing-price{font-size:12px;font-weight:700;opacity:.85;margin-top:1px}

/* Preview row above composer */
.cd-preview{display:flex;align-items:center;gap:8px;padding:6px 10px;background:#0A0A0A;border-top:1px solid #2A2520}
.cd-preview-thumb{width:38px;height:38px;border-radius:6px;overflow:hidden;background:#1E1E1E;flex-shrink:0;display:flex;align-items:center;justify-content:center;color:#BFA164;font-size:20px}
.cd-preview-thumb img,.cd-preview-thumb video{width:100%;height:100%;object-fit:cover}
.cd-preview-name{flex:1;min-width:0;color:#F5F0E8;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.cd-preview-x{background:none;border:none;color:#A09888;font-size:18px;width:28px;height:28px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center}
.cd-preview-x:hover{background:rgba(255,255,255,.08);color:#FF6B6B}

.cd-composer{display:flex;align-items:center;gap:6px;padding:8px 10px;background:#141414;border-top:1px solid #2A2520;position:relative}
.cd-attach-wrap{position:relative}
.cd-attach{background:none;border:none;color:#A09888;font-size:22px;width:34px;height:34px;border-radius:50%;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center}
.cd-attach:hover{color:#BFA164;background:rgba(191,161,100,.08)}
.cd-attach-menu{position:absolute;bottom:42px;left:0;background:#1E1E1E;border:1px solid #2A2520;border-radius:10px;padding:4px;min-width:140px;box-shadow:0 4px 18px rgba(0,0,0,.4);z-index:10}
.cd-attach-menu button{display:flex;align-items:center;gap:8px;width:100%;background:none;border:none;color:#F5F0E8;padding:8px 10px;font-size:13px;border-radius:6px;text-align:left;cursor:pointer}
.cd-attach-menu button:hover{background:rgba(191,161,100,.12);color:#BFA164}
.cd-attach-menu .mdi{font-size:18px}

.cd-input{flex:1;background:#0F0F0F;border:none;border-radius:18px;padding:8px 14px;color:#F5F0E8;font-size:14px;outline:none;min-width:0}
.cd-send{background:none;border:none;color:#BFA164;font-size:22px;width:34px;height:34px;flex-shrink:0;cursor:pointer;border-radius:50%;display:flex;align-items:center;justify-content:center}
.cd-send:hover:not(:disabled){background:rgba(191,161,100,.08)}
.cd-send:disabled{opacity:.4;cursor:default}
.mdi-spin{animation:cd-spin 1s linear infinite}
@keyframes cd-spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}

@media (max-width:768px){
  .cd-dock{right:0;left:0;width:100%;max-width:100%;border-radius:14px 14px 0 0;
           bottom:calc(82px + env(safe-area-inset-bottom, 0px));
           height:calc(70vh - env(safe-area-inset-bottom, 0px));max-height:70vh}
  .cd-dock.minimized{width:100%;height:auto;bottom:calc(82px + env(safe-area-inset-bottom, 0px))}
  .cd-bubble{max-width:88%}
  .cd-img,.cd-video{max-width:240px}
}
</style>
